
import { Vue, Component, Watch } from "vue-property-decorator";
import menuTitle from "../components/menu-title.vue";
import dayjs from "dayjs";
@Component({
  components: {
    menuTitle,
  },
})
export default class Ccass extends Vue {
  public name: string = "Ccass";
  code: string = "";
  sname: string = "";
  queryDate: string | Date = "";
  list: GAPI.holderDetailItem[] = [];
  loading: boolean = false;
  headers: views.header[] = [
    {
      key: "index",
      title: "序列",
      width: 60,
    },
    {
      title: "席位ID",
      key: "participantId",
      width: 90,
    },

    {
      title: "券商名称",
      key: "participantCN",
      width: 280,
      align: "left",
    },
    {
      title: "持股量",
      key: "holding",
      width: 160,
      align: "right",
      sortable: true,
      sortType: "asc",
    },
    {
      title: "最后交易日",
      key: "lastChangeDay",
      width: 150,
      align: "right",
    },
    {
      title: "持仓占比%",
      key: "stake",
      width: 100,
      align: "right",
    },
    {
      title: "累计持仓占比%",
      key: "cumulStake",
      width: 150,
      align: "right",
      sortable: true,
    },
  ];
  summarys: GAPI.holderOverviewItem[] = [];
  summarys_header: views.header[] = [
    {
      title: "持有者类型",
      key: "typeOfHolderCN",
      width: 220,
    },
    {
      title: "持股量",
      key: "holding",
      width: 160,
      align: "right",
    },
    {
      title: "持仓占比",
      key: "stake",
      align: "right",
    },
  ];
  async fetchData(code: string, timestamps: number) {
    const {
      data: { holderOverview = [], holderDetail = [], name = "", stockCode },
    } = await this.$api.GetCassStockBroker({
      stockCode: code,
      time: timestamps,
    });
    this.summarys = holderOverview.map((i) => {
      i.holding = i.holding.toLocaleString();
      return i;
    });
    this.list = holderDetail || [];
    this.sname = name;
    this.$router.replace({
      name: "xccass",
      params: {
        code: `${code}`,
      },
      query: {
        startTime: dayjs(this.queryDate).format("YYYY-MM-DD"),
      },
    });
  }
  rowClassName(row: any, index: number) {
    if (index === 2 || index === 5 || index == 7) {
      return "show-border";
    } else {
      return "no-border";
    }
  }
  get selectedTimeStamps() {
    return dayjs(this.queryDate).unix();
  }
  mounted() {
    const code = this.$route.params.code;
    this.code = code;
    this.queryDate =
      this.$route.params.startTime ||
      dayjs()
        .subtract(1, "day")
        .toDate();
    this.fetchData(`${code}`, this.selectedTimeStamps);
  }
}
